<section>
    <div>
        <div class="files-list">
            <div class="single-file" [ngClass]="{'error-parsing': showError}" *ngFor="let file of files; let i = index">
                <div class="d-flex" style="justify-content: space-between;flex-grow: 1;">
                    <img src="../../../../../assets/Icon-svgs/ic-file.svg" width="45px" alt="file">
                    <div class="info">
                        <span class="name">
                            {{ file?.name }}
                        </span>
                        <p class="size">
                            {{ formatBytes(file?.size) }}
                        </p>
                        <!-- <app-progress-indicator [progress]="file?.progress"></app-progress-indicator> -->
                    </div>
                </div>
                <div class="error-text" *ngIf="showError">Error in the file.</div>
            </div>
        </div>

        <div class="fileupload-container d-flex" style="flex-direction: column;" appDnd
            (fileDropped)="isDismissable ? '': onFileDropped($event)">
            <input type="file" [multiple]="false" #fileDropRef id="fileDropRef"
                (change)="fileBrowseHandler($event.target)" [disabled]="isDismissable" accept=".csv"/>
            <img src="../../../../../assets/Icon-svgs/ic-upload-file.svg" class="mb-3 ic-upload" alt="">
            <span class="mb-2">Drag and drop (CSV) file here</span>
            <span class="mb-2">or</span>
            <div class="d-flex justify-content-center">
                <button [disabled]="isDismissable" (click)="fileBrowseHandler(fileDropRef)"
                    class="primaryBtn">
                    <span class="button-icon">
                        <i class="far fa-file"></i>
                    </span>
                    <span class="btnContent">
                        Browse for file
                    </span>
                </button>
            </div>
        </div>
    </div>
</section>